import SfDemo from './SfDemo.jsx';

export default () => {
    return {
        path: '/SfDemo',
        element: <SfDemo />,
    }
}